import { defineType } from 'sanity'

export default defineType({
  name: 'sectionTheme',
  title: 'Section Theme',
  type: 'string',
  options: {
    list: [
      { title: 'Default (white bg, dark text)', value: 'default' },
      { title: 'Dark (dark bg, white text)', value: 'dark' },
      { title: 'Brand (red bg, white text)', value: 'brand' },
    ],
  },
  initialValue: 'default',
  description: 'Background & text colors.',
})